import styled from 'styled-components'

import * as resultMetaStyles from 'modules/resultsV2/ResultMeta.styles'

const METADATA_LABEL_COLUMN_WIDTH = '248px'

export const MetadataRow = styled(resultMetaStyles.MetadataRow)`
  align-items: center;
  grid-template-columns: ${METADATA_LABEL_COLUMN_WIDTH} 1fr;
`

export {
  ItemRow,
  MetadataLabel,
  MetadataSection,
  MetadataSubsection,
  MetadataSubsectionTitle,
  MetadataValue
} from 'modules/resultsV2/ResultMeta.styles'
